module.exports = __webpack_public_path__ + "img/1686882753330-IMG_2830.png.9434ae13.webp";